<template>
    <div class="container-fluid">
        <div class="page-heading mb-4">
            <p class="page-eyebrow">DELEGATE ENGAGEMENT</p>
            <h1 class="h3 mb-1 text-gray-800">Delegate Questions</h1>
            <p class="mb-0 text-muted">Review, resolve, and manage questions submitted during event sessions.</p>
        </div>

        <EventDetailQuestionList></EventDetailQuestionList>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import EventDetailQuestionList from "@/components/event/EventDetailQuestionList.vue";

export default defineComponent({
    name: "EventDetailQuestionPage",
    components: {
        EventDetailQuestionList
    },
})
</script>



<style scoped>
.page-heading {
    border-bottom: 1px solid #e2e6ea;
    padding-bottom: 1rem;
}

.page-eyebrow {
    color: #426cc6;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin: 0 0 0.35rem;
}
</style>
